/**
 * Badge Atom
 *
 * Badge/Tag para status e labels
 */
import React from 'react'

const variants = {
	green: 'bg-success/20 text-success',
	red: 'bg-danger/20 text-danger',
	blue: 'bg-info/20 text-info',
	yellow: 'bg-warning/20 text-warning',
	gray: 'bg-base-400 text-text-body',
	purple: 'bg-purple-500/20 text-purple-400',
	primary: 'bg-primary/20 text-primary',
}

const sizes = {
	sm: 'px-2 py-0.5 text-xs',
	md: 'px-2.5 py-1 text-xs',
	lg: 'px-3 py-1.5 text-sm',
}

export default function Badge({
	children,
	variant = 'gray',
	size = 'md',
	dot = false,
	className = '',
}) {
	return (
		<span
			className={`
        inline-flex items-center font-medium rounded-full
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `}
		>
			{dot && (
				<span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${variant === 'green' ? 'bg-green-500' : variant === 'red' ? 'bg-red-500' : 'bg-current'}`} />
			)}
			{children}
		</span>
	)
}
